export default "__VITE_ASSET__DQ205V1A__"